<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">Depunerea unei contestații</h1>

      <p>
        Uneori este necesară depunerea unei contestații pentru remedierea neregulilor apărute în cadrul procedurii de atribuire. Pentru a garanta mecanisme eficiente și rapide, a fost publicată <strong>Legea 101/2016</strong> privind remediile și căile de atac în materie de achiziții publice.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-university me-2"></i>Unde se depune?</h5>
      <p>
        Contestația se poate depune la:
      </p>
      <ul>
        <li><i class="fas fa-gavel me-2 text-primary"></i>Consiliul Național de Soluționare a Contestațiilor (CNSC)</li>
        <li><i class="fas fa-scale-balanced me-2 text-primary"></i>Instanța de judecată – Curtea de Apel</li>
      </ul>
      <p>Recomandăm CNSC, datorită rapidității și posibilității de atacare ulterioară la Curtea de Apel.</p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-clock me-2"></i>Termene (Art. 8 – Legea 101/2016)</h5>
      <ul>
        <li><strong>10 zile</strong> – pentru proceduri ce depășesc pragurile valorice UE (licitații deschise/închise)</li>
        <li><strong>7 zile</strong> – pentru proceduri sub pragurile UE (proceduri simplificate)</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-file-alt me-2"></i>Conținutul contestației (Art. 10)</h5>
      <ul>
        <li>Datele complete ale contestatorului</li>
        <li>Denumirea și sediul autorității contractante</li>
        <li>Obiectul contractului, procedura, numărul și data anunțului SEAP</li>
        <li>Actul atacat și obiectul contestației</li>
        <li>Motivarea în fapt și în drept</li>
        <li>Mijloacele de probă (dacă există)</li>
        <li>Semnătura contestatorului sau reprezentantului legal</li>
      </ul>
      <p class="text-muted">
        Atenție: nu se pot adăuga motive noi ulterior termenului legal. CNSC poate cere completări în 3 zile, altfel contestația se anulează.
      </p>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-paper-plane me-2"></i>Transmitere</h5>
      <ul>
        <li>Încărcare în SEAP</li>
        <li>Trimitere prin email/fax la autoritatea contractantă + CNSC/Curte</li>
        <li>Transmitere în aceeași zi prin poștă sau curier</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-coins me-2"></i>Cauțiune</h5>
      <ul>
        <li>Se depune în maxim 5 zile</li>
        <li>Valoare: 2% din valoarea estimată</li>
        <li>Plată la Trezorerie sau CEC</li>
        <li>Copie trimisă pe email la <strong>office@cnsc</strong>, originalul prin poștă</li>
        <li>Se restituie la cerere după soluționare (în medie după 60 zile)</li>
      </ul>

      <h5 class="mt-4 fw-semibold"><i class="fas fa-scale-unbalanced me-2"></i>Hotărâri posibile ale CNSC</h5>
      <ul>
        <li><i class="fas fa-times-circle me-2 text-danger"></i>Anularea actului atacat (total/parțial)</li>
        <li><i class="fas fa-edit me-2 text-warning"></i>Obligarea autorității să remedieze legal situația</li>
        <li><i class="fas fa-ban me-2 text-danger"></i>Anularea întregii proceduri</li>
      </ul>

      <p class="mt-4">
        În concluzie, contestarea este o opțiune importantă, dar trebuie analizată cu grijă. Aceasta poate avea impact asupra relației ulterioare cu autoritatea contractantă.
        <br /><br />
        Pentru consultanță profesională privind depunerea contestațiilor, ne poți contacta la:  
        <strong><i class="fas fa-envelope me-1"></i>contact@consultantaachizitii.ro</strong>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContestatiiPage'
}
</script>
